import React, { useState, useEffect } from "react";
import config from "../../config/config.json";
import { apiCall } from "../../_services/apiCall";
import { Modal, ModalHeader } from "../../globalComponents/ui/Modal";
import { PrimaryButton, SecondaryButton, DangerButton } from "../../globalComponents/ui/Button";
import {
  SettingsPage,
  SettingsTopBar, SettingsTopBarLeft, SettingsTopBarRight,
  SettingsAccentBar, SettingsTopBarTitle, SettingsTopBarSub,
  SettingsContent,
  SettingsCard, SettingsSectionHeader, SettingsSectionTitle, SettingsCountChip,
  SettingsFilterCard, SettingsSearchWrap,
  SettingsEmptyState,
  SettingsModalBody, SettingsModalFooter,
  SettingsFormGroup, SettingsFormLabel, SettingsFormInput,
} from "./SettingShell";
import DataTable from "../../globalComponents/ui/DataTable/DataTable";

const Generator = ({ userPermissionList }) => {
  const [processDataList, setProcessDataList] = useState([]);
  const [filterListValue, setFilterListValue] = useState([]);
  const [showAddProcess, setAddProcessShow] = useState(false);
  const [showSkelton, setshowSkelton] = useState(false);
  const [showLoder, setshowLoder] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [processName, setProcessName] = useState("");
  const [isError, setIsError] = useState(false);
  const userId = JSON.parse(localStorage.getItem("user_temp_id"));
  const [mode, setMode] = useState("create");
  const [deleteProcessPopup, setDeleteProcessPopup] = useState(false);

  const canCreate = userPermissionList.some(p => p.permissionCode === "CREATE" && p.checked);
  const canEdit = userPermissionList.some(p => p.permissionCode === "EDIT" && p.checked);
  const canDelete = userPermissionList.some(p => p.permissionCode === "DELETE" && p.checked);

  const handleAddProcessClose = () => {
    setMode("create");
    setIsError(false);
    setProcessName("");
    setAddProcessShow(false);
  };

  const handleShowEditProcess = (id, process) => {
    setSelectedId(id);
    setMode("edit");
    setProcessName(process);
    setAddProcessShow(true);
  };

  const createProcess = async () => {
    setshowLoder(true);
    const { isSuccess } = await apiCall(`${config.POSTLOGIN_API_URL_COMPANY}createProcess`, {}, { process: processName, created_by: userId }, "POST");
    setshowLoder(false);
    if (isSuccess) {
        getProcess();
        handleAddProcessClose();
    }
  };

  const getProcess = async () => {
    setshowSkelton(true);
    const { isSuccess, data } = await apiCall(`${config.POSTLOGIN_API_URL_COMPANY}getProcess`, {}, {}, "GET");
    setshowSkelton(false);
    if (isSuccess) {
      const reversed = data?.data?.reverse() || [];
      setProcessDataList(reversed);
      setFilterListValue(reversed);
    }
  };

  const updateProcess = async () => {
    setshowLoder(true);
    const { isSuccess } = await apiCall(`${config.POSTLOGIN_API_URL_COMPANY}updateProcess`, {}, { process: processName, id: selectedId }, "POST");
    setshowLoder(false);
    if (isSuccess) {
      getProcess();
      handleAddProcessClose();
    }
  };

  const deleteProcess = async () => {
    const { isSuccess } = await apiCall(`${config.POSTLOGIN_API_URL_COMPANY}deleteProcess`, {}, { id: selectedId }, "POST");
    if (isSuccess) {
      getProcess();
      setDeleteProcessPopup(false);
    }
  };

  const handleSearch = (searchTerm) => {
    const q = searchTerm.toLowerCase().trim();
    if (!q) {
      setFilterListValue(processDataList);
    } else {
      setFilterListValue(processDataList.filter(item => item.process.toLowerCase().includes(q)));
    }
  };

  useEffect(() => {
    getProcess();
  }, []);

  return (
    <SettingsPage>
      <SettingsTopBar>
        <SettingsTopBarLeft>
          <SettingsAccentBar />
          <div>
            <SettingsTopBarTitle>Process Generator</SettingsTopBarTitle>
            <SettingsTopBarSub>Manage business processes and operational workflows</SettingsTopBarSub>
          </div>
        </SettingsTopBarLeft>
        <SettingsTopBarRight>
          {canCreate && (
            <PrimaryButton onClick={() => setAddProcessShow(true)}>
              <i className="fas fa-plus" style={{ marginRight: 8 }} /> Add Process
            </PrimaryButton>
          )}
        </SettingsTopBarRight>
      </SettingsTopBar>

      <SettingsContent $wide>
        <SettingsFilterCard>
          <SettingsSearchWrap>
            <i className="fas fa-search" />
            <input 
                type="search" 
                placeholder="Search processes..." 
                onChange={(e) => handleSearch(e.target.value)}
            />
          </SettingsSearchWrap>
        </SettingsFilterCard>

        <SettingsCard>
            <SettingsSectionHeader>
                <i className="fas fa-cog" style={{ fontSize: 12, color: "#3f88a5" }} />
                <SettingsSectionTitle>Available Processes</SettingsSectionTitle>
                <SettingsCountChip>{filterListValue.length}</SettingsCountChip>
            </SettingsSectionHeader>
            <DataTable
              title=""
              searchable={false}
              showPagination={filterListValue.length > 20}
              columns={[
                { key: "process", label: "Process Name", sortable: true },
              ]}
              data={filterListValue.map(d => ({ _id: d.id, process: d.process, _raw: d }))}
              emptyMessage="No processes found matching your search."
              extraActions={(row) => [
                ...(row._raw.is_deletable && canEdit ? [{ label: "Edit", icon: "fas fa-edit", variant: "edit", onClick: () => handleShowEditProcess(row._raw.id, row._raw.process) }] : []),
                ...(row._raw.is_deletable && canDelete ? [{ label: "Delete", icon: "fas fa-trash-alt", variant: "del", onClick: () => { setSelectedId(row._raw.id); setDeleteProcessPopup(true); } }] : []),
              ]}
            />
        </SettingsCard>
      </SettingsContent>

      <Modal show={showAddProcess} onClose={handleAddProcessClose}>
        <ModalHeader icon="fas fa-cog" title={`${mode === "create" ? "Create" : "Update"} Process`} />
        <SettingsModalBody>
            <SettingsFormGroup>
                <SettingsFormLabel>Process Name</SettingsFormLabel>
                <SettingsFormInput 
                    type="text"
                    value={processName}
                    placeholder="Enter process name"
                    onChange={(e) => {
                        const val = e.target.value;
                        const isDup = processDataList.some(d => d.process === val && d.id !== selectedId);
                        setProcessName(val);
                        setIsError(isDup);
                    }}
                />
                {isError && <small style={{ color: "#ef4444", marginTop: 4, display: "block" }}>This process name already exists.</small>}
            </SettingsFormGroup>
        </SettingsModalBody>
        <SettingsModalFooter>
            <SecondaryButton onClick={handleAddProcessClose}>Cancel</SecondaryButton>
            <PrimaryButton 
                onClick={mode === "create" ? createProcess : updateProcess}
                disabled={showLoder || isError || !processName.trim()}
            >
                {showLoder ? "Saving..." : (mode === "create" ? "Create Process" : "Update Process")}
            </PrimaryButton>
        </SettingsModalFooter>
      </Modal>

      <Modal show={deleteProcessPopup} onClose={() => setDeleteProcessPopup(false)}>
        <ModalHeader icon="fas fa-exclamation-triangle" title="Confirm Delete" />
        <SettingsModalBody>
            <p style={{ margin: 0 }}>Are you sure you want to delete this process? This action cannot be undone.</p>
        </SettingsModalBody>
        <SettingsModalFooter>
            <SecondaryButton onClick={() => setDeleteProcessPopup(false)}>Cancel</SecondaryButton>
            <DangerButton onClick={deleteProcess}>Delete Process</DangerButton>
        </SettingsModalFooter>
      </Modal>
    </SettingsPage>
  );
};

export default Generator;
